<template>
    <ul class="snoop-footer__meta">
        <li
            v-for="link in links"
            :key="link.href"
            class="snoop-footer__meta-item"
        >
            <a
                :href="link.href"
                class="snoop-footer__meta-link"
                :title="link.title"
                rel="noopener"
                target="_blank"
            >
                <snoop-html-content :html="link.text" />
            </a>
        </li>
    </ul>
</template>

<script>
import SnoopHtmlContent from './HtmlContent.vue'


export default {
    components: { SnoopHtmlContent },

    props: {
        translations: { type: Object, required: true },
    },

    data () {
        return {
            links: [
                { text: this.translations.links.imprint.linkText, title: this.translations.links.imprint.title, href: this.translations.links.imprint.link },
                { text: this.translations.links.dataPrivacy.linkText, title: this.translations.links.dataPrivacy.title, href: this.translations.links.dataPrivacy.link },
            ],
        }
    },
}
</script>
